'use client';
import { em, useMantineTheme, px } from '@mantine/core';
import { useCss } from './use-css.mjs';

function getStylesRef(refName) {
  return `___ref-${refName || ""}`;
}
function getBreakpointValue(theme, breakpoint) {
  return breakpoint in theme.breakpoints && typeof breakpoint !== "number" ? px(theme.breakpoints[breakpoint]) : px(breakpoint);
}
const getHelpers = (theme) => ({
  light: '[data-mantine-color-scheme="light"] &',
  dark: '[data-mantine-color-scheme="dark"] &',
  rtl: '[dir="rtl"] &',
  ltr: '[dir="ltr"] &',
  notRtl: '[dir="ltr"] &',
  notLtr: '[dir="rtl"] &',
  ref: getStylesRef,
  smallerThan: (breakpoint) => `@media (max-width: ${em(getBreakpointValue(theme, breakpoint) - 0.1)})`,
  largerThan: (breakpoint) => `@media (min-width: ${em(getBreakpointValue(theme, breakpoint))})`
});
function createStyles(input) {
  const getCssObject = typeof input === "function" ? input : () => input;
  return function useStyles(params) {
    const theme = useMantineTheme();
    const helpers = getHelpers(theme);
    const cssObject = getCssObject(theme, params, helpers);
    const { css, cx } = useCss();
    const classes = Object.keys(cssObject).reduce((acc, key) => {
      acc[key] = css(cssObject[key]);
      return acc;
    }, {});
    return { classes, cx, theme };
  };
}

export { createStyles, getHelpers, getStylesRef };
//# sourceMappingURL=create-styles.mjs.map
